import styled from "styled-components";

export const Maintitle = styled.h5`
  background: #00c269;
  color: #fff;
  padding: 15px;
  text-align: right;
  border-radius: 5px 5px 0 0;
  font-weight: 600;
`;


export const ContairnerBg = styled.div`
  background: #fff;
  border-radius: 0 0 10px 10px;
  padding: 15px;

  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .075);
`